import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout";
import { SplashScreen } from "../../../_metronic/_partials/controls";
import CustomerSaleReport from "./customer-sale-report";
import ItemWiseSaleReport from "./ItemwiseSaleReport";
import AreaWise from "./area-wise";
import ProductBased from "./product-based";
import ShopBased from "./shop-based";
import CategoryBased from "./category-based";
import CustomerListByDate from "./customer-listby-date";
import CategoryTreeBased from "./category-based/CategoryTreeBased";
import FreeProduct from "./free-product";
import AbandonCart from "./eventLogWise/AbandonCart";
import HomePageVisit from "./eventLogWise/HomePageVisit";

export default function ReportPages() {
  return (
    <Suspense fallback={<SplashScreen />}>
      <Switch>
        {<Redirect exact from="/report" to="/report/product-based-reports" />}

        <ContentRoute
          path="/report/sale-report-customer"
          component={CustomerSaleReport}
        />
        <ContentRoute
          path="/report/item-wise-sales"
          component={ItemWiseSaleReport}
        />

        <ContentRoute path="/report/areawise-reports" component={AreaWise} />
        <ContentRoute
          path="/report/product-based-reports"
          component={ProductBased}
        />
        <ContentRoute path="/report/shop-based-reports" component={ShopBased} />
        <ContentRoute
          path="/report/category-based-reports"
          component={CategoryBased}
        />
        <ContentRoute
          path="/report/customer-list-bydate"
          component={CustomerListByDate}
        />
        <ContentRoute
          path="/report/category-tree-based-reports"
          component={CategoryTreeBased}
        />

        <ContentRoute
          path="/report/free-product-report"
          component={FreeProduct}
        />
	<ContentRoute
          path="/report/abandon-cart-reports"
          component={AbandonCart}
        />
        <ContentRoute
          path="/report/home-page-visit-reports"
          component={HomePageVisit}
        />
      </Switch>
    </Suspense>
  );
}
